import classNames from "classnames";
import 'bootstrap-pincode-input';
import 'bootstrap-pincode-input/css/bootstrap-pincode-input.css';

import { DComponent } from "../../../DComponent";
import { validate, validateCode } from "../../../../utils/validate";
import { Auth } from "../../../../models/auth";
import { apiConfirmAuth, apiSendConfirmation } from "../../../../utils/api";
import { FireBase } from "../../../../utils/firebase";
import { countDown } from "../../../../utils/date";
import Env from "../../../../environments";

export default class ConfirmOTP extends DComponent {
  constructor({
    parent,
    id,
    provider,
    identity,
    accessToken,
    cancelButton,
    onCancel = () => { },
    onSubmit = () => { },
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("ConfirmOTP", {
        "has-cancel": cancelButton
      }),
      cancelButton: cancelButton
    });
    this.provider = provider;
    this.identity = identity;
    this.accessToken = accessToken;
    this.onSubmit = onSubmit;
    /** @type {InputField}*/
    this.email = undefined;
    this.confirmCodeIsLogin = false;
    this.cancelButton = cancelButton;
    this.onCancel = onCancel;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "ConfirmOTP");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.addEvent();
  }

  addEvent() {
    $(".confirm-code > input[name=phone]", this.element).pincodeInput({
      inputs: 6, hidedigits: false, keydown: () => {
        $(".message", this.element).removeClass("error");
        $(".message", this.element).text("");
        this.oldConfirmCode = "";
      }, complete: (value, e) => {
        e.preventDefault();
        if (value !== this.oldConfirmCode) {
          this.oldConfirmCode = value;
          $(".btn.continue", this.element).trigger("click");
        }
      }
    });

    $(".confirm-code .pincode-input-container input", this.element).on("keyup", (e) => {
      if (e.key === 'Enter' || e.keyCode === 13) {
        $(".btn.continue", this.element).trigger("click");
      }
    });

    $(".btn.continue", this.element).on("click", (e) => {
      e.preventDefault();
      this.submitCode();
    })

    $(".resend", this.element).on("click", (e) => {
      e.preventDefault();
      this.resendCode();
    });

    $(".btn-cancel", this.element).on("click", (e) => {
      e.preventDefault();
      typeof this.onCancel && this.onCancel();
    })

    if (!Env.DUTY_CAST_EXTENSION_DEBUG_MODE) {
      $(".code-confirm", this.element).addClass("hide");
    }

    $(".code-confirm", this.element).on("click", (e) => {
      let val = $(e.currentTarget).text();
      if (val) {
        this.setOTPCode(val);
      }
    })
  }

  submitCode() {
    if (this.validateConfirmCode()) {
      let confirmCode = this.getOTPCode();
      this.setLoading(true);

      switch (this.provider) {
        case Auth.TYPE.FIREBASE_PHONE:
          FireBase.confirmPhone(confirmCode, this.confirmCodeIsLogin, (user) => {
            user.getIdToken().then((data) => {
              this.confirmCodeApi(data);
            }).catch((error) => {
              this.confirmCodeError(error);
            });
          }, (error) => {
            this.confirmCodeError(error);
          });
          break;

        default:
          this.confirmCodeApi(confirmCode);
          break;
      }
    } else {
      this.confirmCodeError();
    }
  }

  confirmCodeApi(confirmCode) {
    let params = {
      "provider": this.provider,
      "identity": this.identity,
      "access_token": this.accessToken,
      "password": confirmCode
    }
    apiConfirmAuth(params, (data) => {
      this.setLoading(false)
      const user = Auth.fromApiObject(data);
      if (user.authToken) {
        user.saveLoginInfo();
        window.resendCount && clearInterval(window.resendCount);
        this.resetConfirmCode();
        this.setLoading(false);
        typeof (this.onSubmit) === "function" && this.onSubmit(user);
      } else {
        if (data.data?.access_token) {
          this.accessToken = data.data?.access_token;
        }
        this.confirmCodeError();
      }
    }, (error) => {
      this.confirmCodeError(error);
    });
  }

  resendCode() {
    this.setLoading(true);

    switch (this.provider) {
      case Auth.TYPE.FIREBASE_PHONE:
        FireBase.setupPhone(this.identity, (confirmationResult) => {
          this.showConfirmOTP(confirmationResult);
        }, (error) => {
          this.confirmCodeError(error);
        });
        break;

      default:
        let params = {
          "provider": this.provider,
          "identity": this.identity
        }
        apiSendConfirmation({
          ...params,
          access_token: this.accessToken
        },
          (data) => {
            if (data?.data?.access_token) {
              this.accessToken = data.data.access_token;
              this.showConfirmOTP();
            } else {
              this.confirmCodeError();
            }
          },
          (error) => {
            this.confirmCodeError(error);
          }
        )
        break;
    }
  }

  showConfirmOTP(confirmationResult) {
    this.confirmCodeIsLogin = true;
    window.confirmationResult = confirmationResult;
    this.resetConfirmCode();
    this.resendHandle();
    this.setLoading(false);
    $(".confirm-code > input[name=phone]", this.element).pincodeInput().data('plugin_pincodeInput').focus();
  }

  resendHandle() {
    window.resendCount && clearInterval(window.resendCount);
    window.resendCount = countDown(Env.DUTY_CAST_EXTENSION_CONFIRM_PHONE_RESEND_DELAY ?? 60, (count) => {
      let text = `(${count})`;
      if (count > 0) {
        $(".resend", this.element).removeClass("count-down").addClass("count-down");
      } else {
        text = "";
        $(".resend", this.element).removeClass("count-down");
      }
      $(".resend .count", this.element).text(text);
    })
  }

  resetConfirmCode() {
    $(".confirm-code input", this.element).val("");
    $(".message", this.element).text("");
    $(".message", this.element).removeClass("error");
  }

  validateConfirmCode() {
    return validate({ selector: $(".confirm-code > input", this.element), validator: validateCode });
  }

  confirmCodeError(error) {
    $(".message", this.element).text(error && error.message ? error.message : $.i18n("login_confirmInvalid"));
    $(".message", this.element).addClass("error");
    this.setLoading(false);
    $(".confirm-code input.pincode-input-text", this.element).each(function () {
      if (!this.value) {
        this.focus();
        return false;
      }
    });
  }

  /** @param {ConfirmOTP} _params */
  updateAttributes(_params = {}) {
    Object.keys(_params).forEach(key => {
      this[key] = _params[key];
    });
  }

  setOTPCode(val) {
    $(".confirm-code > input", this.element).val(val || "");
    let pinCode = $(".confirm-code input.pincode-input-text", this.element);
    if (pinCode.length > 1) {
      pinCode.each(function (index, obj) {
        this.value = val[index] || "";
      });
    } else {
      pinCode.val(val);
    }
  }

  getOTPCode() {
    return $(".confirm-code > input", this.element).val();
  }

  setCodeConfirm(code = "") {
    $(".code-confirm", this.element).text(code || "");
  }

  setLoading(isLoading) {
    $(".btn.continue", this.element).toggleClass("loading", isLoading)
  }
}